import checkSheet from "./checkSheet";

export function changeTexture(obj, image) {
  const ssheet = checkSheet(image);
  ssheet ? obj.loadTexture(ssheet, image) : obj.loadTexture(image);
  return obj;
}
